import { Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { ImpressumComponent } from './pages/impressum/impressum.component';
import { PrivacyNoticeComponent } from './pages/privacy-notice/privacy-notice.component';

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'impresszum', component: ImpressumComponent },
  { path: 'adatkezelesi-tajekoztato', component: PrivacyNoticeComponent },
  { path: '**', redirectTo: '' },
];
